import BConfig from "../../modules/BConfig";
import BQuantity from "./BQuantity";

export default class BEnergy
{
	constructor(amount, unit)
	{
		this.amount = amount;
		this.unit = unit;
	}

	static getKjToKcalFactor()
	{
		return BConfig.getKjToKcalFactor();
	}

	static getCalToJFactor()
	{
		return 1 / this.getKjToKcalFactor();
	}

	getJoules()
	{
		const calToJ = BEnergy.getCalToJFactor();

		switch (this.unit.toUpperCase()) {
			case "J":
				return this.amount;
			case "KJ":
				return this.amount * 1000;
			case "CAL":
				return this.amount * calToJ;
			case "KCAL":
				return this.amount * calToJ * 1000;
		}
	}

	getQuantity(unit)
	{
		const calToJ = BEnergy.getCalToJFactor();

		switch (unit.toUpperCase()) {
			case "J":
				return new BQuantity(this.getJoules(), "J");
			case "KJ":
				return new BQuantity(this.getJoules() * 0.001, "kJ");
			case "CAL":
				return new BQuantity(this.getJoules() * (1 / calToJ), "cal");
			case "KCAL":
				return new BQuantity(this.getJoules() * (1 / calToJ) * 0.001, "kcal");
		}
	}
}
